export const educationData = [
    {
        id: 1,
        institution: 'The University Of Faisalabad (TUF)',
        course: 'BSCS',
        startYear: '2020',
        endYear: '2024'
    },
    {
        id: 2,
        institution: 'Punjab Group Of Colleges FSD',
        course: 'FSC (Pre Eng)',
        startYear: '2018',
        endYear: '2020'
    },
    {
        id: 3,
        institution: 'Sandal School',
        course: 'Metric (Science)',
        startYear: '2016',
        endYear: '2018'
    },
    {
        id: 4,
        institution: 'Career Institute',
        course: 'Web-Development',
        startYear: '2022',
        endYear: '2022'
    },
]